module.exports = __webpack_public_path__ + "img/tom_v.8935e456.jpg";